import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ReportTemplate from "../ReportTemplate/ReportTemplate";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { getCiData } from "../../../db/users";
import "./DownloadConsentment.css";

function DownloadConsentment() {
  const { doctorId, patientId } = useParams();
  const [ciData, setCiData] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchConsentmentData() {
      setIsLoading(true);
      const response = await getCiData(patientId, doctorId);
      setCiData(response);
      setIsLoading(false);
    }
    fetchConsentmentData();
  }, []);

  isLoading && <p>Cargando datos del consentimiento informado...</p>;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {ciData && (
        <PDFDownloadLink
          style={{ textDecoration: "none", fontSize: "30px", color: "white" }}
          document={<ReportTemplate ciData={ciData} />}
          fileName="consentimiento_informado.pdf"
        >
          {({ blob, url, loading, error }) =>
            !loading ? (
              <div className="downloadContainer">
                <div className="consentmentButton">
                  <p>Descargar consentimiento informado</p>
                </div>
              </div>
            ) : (
              "Descargar consentimiento informado"
            )
          }
        </PDFDownloadLink>
      )}
    </div>
  );
}

export default DownloadConsentment;
